var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-dropdown",
    {
      directives: [
        {
          name: "b-tooltip",
          rawName: "v-b-tooltip.hover",
          modifiers: { hover: true },
        },
      ],
      staticClass: "d-inline-block",
      attrs: {
        split: "",
        variant: "outline-light",
        "menu-class": "p-4",
        title: _vm.tooltip,
        "toggle-class": _vm.menuDisabled ? "d-none" : "d-inline-block",
      },
      on: { click: _vm.onButtonClick },
      scopedSlots: _vm._u(
        [
          {
            key: "button-content",
            fn: function () {
              return [_vm._t("placeholder")]
            },
            proxy: true,
          },
        ],
        null,
        true
      ),
    },
    [
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "d-flex flex-column align-items-start",
          staticStyle: { gap: "8px", "min-width": "150px" },
        },
        [
          _c("label", [_vm._v(_vm._s(_vm.label))]),
          _vm._v(" "),
          _c("b-form-input", {
            staticStyle: { width: "98px" },
            attrs: { type: "number", min: _vm.min, step: _vm.step },
            on: { input: _vm.emitChange },
            model: {
              value: _vm.localValue,
              callback: function ($$v) {
                _vm.localValue = $$v
              },
              expression: "localValue",
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }